"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALUE_SET = exports.UNTIL_STOCK_LASTS = exports.SOLD_OUT = exports.SALE_LIMITATION = exports.PPA_LABEL = exports.OUT_OF_STOCK = exports.NO_LONGER_FOR_SALE = exports.NOT_SOLD_ONLINE = exports.LOW_STOCK = exports.LAST_CHANCE = exports.COMING_SOON = void 0;
const PPA_LABEL = exports.PPA_LABEL = 'state';
const COMING_SOON = exports.COMING_SOON = 'ComingSoon';
const LAST_CHANCE = exports.LAST_CHANCE = 'LastChance';
const LOW_STOCK = exports.LOW_STOCK = 'LowStock';
const NO_LONGER_FOR_SALE = exports.NO_LONGER_FOR_SALE = 'NoLongerForSale';
const NOT_SOLD_ONLINE = exports.NOT_SOLD_ONLINE = 'NotSoldOnline';
const OUT_OF_STOCK = exports.OUT_OF_STOCK = 'OutOfStock';
const SALE_LIMITATION = exports.SALE_LIMITATION = 'SaleLimitation';
const SOLD_OUT = exports.SOLD_OUT = 'SoldOut';
const UNTIL_STOCK_LASTS = exports.UNTIL_STOCK_LASTS = 'UntilStockLasts';
const VALUE_SET = exports.VALUE_SET = 'ValueSet';
